<template>
  <div>
    <b-overlay :show="loading" rounded="sm" :style="loading ? 'height:800px;overflow:hidden;' : ''">
      <PageValidate ref="ClientList" :MediaListRef="MediaListRef">
        <template v-slot:PageBody>
          <div class="CenterCard">
            <BasicPageTop :Name="$t('lbl_EMPBE_CompanyInfo_ClientList')">
              <template v-slot:Body>
                <div class="BasicTop-Card" v-html="$t('lbl_EMPBE_CompanyInfo_ClientList_Blue_p')">
                </div>
              </template>
            </BasicPageTop>
            <div>
              <div class="row">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    {{ $t("lbl_EMPBE_CompanyInfo_ClientList_MaxClientList") }}
                  </div>
                </div>
                <div class="col-12">
                  <ClientListProps
                    ref="ClientListProps"
                    :nums="20"
                    v-model="form.clients"
                    :CountryOptions="SelectOptions.CountryOptions"
                    :supplierId="supplierId"
                    @removeCertImage="removeCertImage"
                  />
                </div>
              </div>
            </div>
          </div>
        </template>
      </PageValidate>
    </b-overlay>
  </div>
</template>

<script>
import { CompanyInfoService } from "../../_services";
import { LogService } from "../../_services/log.Service";
import BasicPageTop from "./Popup/BasicPageTop.vue"
import ClientListProps from "./Popup/ClientListProps.vue"

export default {
  components: {
    BasicPageTop, ClientListProps,
  },
  inject: {
    permissionData: { default: null },
    companyApprovalHost: { default: null },
  },
  props: ["supplierId", "SelectOptions", "submitType"],
  data() {
    return {
      //Dirty
      loading: false,
      IsCreated: false,
      dirty: false,
      form: {
        empCompanyId: undefined,
        clients: [],
        validationErrorLog: "",
      },
      MediaListRef: [],
      removeCertCommands: [],
    };
  },
  computed: {
    useFormalTables() {
      const host = this.companyApprovalHost;
      return !!(host && host.fromAdmin && host.isApprovalMode);
    },
    user() {
      return this.$store.state.authentication.user;
    },
    langid() {
      return localStorage.getItem("currentLangId");
    },
  },
  watch: {
    form: {
      handler() {
        if (!this.IsCreated) {
          this.dirty = true;
          this.$store.state.dirty = this.dirty;
        }
      },
      deep: true,
    },
    "form.clients": {
      handler(newVal) {
        const newRef = [];
        for (let i = 0; i < newVal.length; i++) {
          newRef.push(`ClientListProps.ClientImageUploader_${i}`);
        }

        this.MediaListRef = [...newRef];
      },
      deep: true,
    },
  },
  mounted() {
    this.InitData();
  },
  methods: {
    resetFilePendingUpdate() {
      this.form.clients = this.form.clients.map(c => {
        return {
          ...c,
          isPendingInsert: false,
          pendingFiles: [],
          updateFileCommands: [],
        }
      });

      this.removeCertCommands = [];
    },

    InitData() {
      this.GetData();
      this.resetFormVerify();
      setTimeout(() => {
        this.dirty = false;
        this.$store.state.dirty = this.dirty;
      }, 200);
    },
    GetData() {
      this.IsCreated = true;
      this.loading = true;
      this.resetFilePendingUpdate();
      CompanyInfoService.GetClientList(this.supplierId, this.useFormalTables).then(res => {
        if (res.isSuccessful) {
          this.form.empCompanyId = res.data.empCompanyId;
          //过滤掉clientName为空的数据
          this.form.clients = res.data.clients?.filter(item => {
            return item.clientName || item.countryId || item.fileName;
          }).sort((a, b) => a.orderId - b.orderId).map((c) => {
            const rid = c.rid ?? c.RID ?? c.Rid ?? c.rID ?? null;
            return {
              ...c,
              rid,
              isPendingInsert: false,
              pendingFiles: [],
              updateFileCommands: [],
            };
          }) ?? [];
        }
        setTimeout(() => {
          this.IsCreated = false;
        }, 500);
      }).catch((err) => {
        console.error(err);
      }).finally(() => {
        this.loading = false;
      });
    },
    //重置表单验证
    resetFormVerify() {
      this.$refs.ClientList.reset();
    },

    fileUploadHandle(isSubmit) {
      const pendingFiles = [];

      this.form.clients.reduce((acc, curr) => {
          return curr.pendingFiles && curr.pendingFiles.length > 0 ? [...acc, ...curr.pendingFiles] : acc;
      }, []).forEach(f => {
        pendingFiles.push({
          ...f,
        })
      });

      return this.$submitFormMessage.FileUploadHandleWithPopup({
        isSubmit,
        pendingFiles,
        commands: [],
        getFailedText: {
          CompanyClient_Logo: this.$t("lbl_EMPBE_CompanyInfo_Certification_CertImage"),
        },
        uploadFinishCallback: (failedFilesFields) => this.$emit("uploadFinish", failedFilesFields)
      });
    },

    //整理結果提交save
    async AfterSaveResult(isSubmit) {
      this.form.validationErrorLog = "";

      const data = {
        ...this.form,
      };

      try {
        const res = await this.fileUploadHandle(isSubmit);

        data.clients = data.clients.map((d, i) => {
          const data = {
            empCompanyId: d.empCompanyId,
            orderId: i + 1,
            clientName: d.clientName,
            countryId: d.countryId,
            fileId: d.fileId || null,
            fileName: d.fileName || null
          };

          if (d.pendingFiles && d.pendingFiles.length > 0) {
            const pendingFileId = d.pendingFiles[0].id;
            const isUploaded = res?.successfulList?.find((u) => u.id === pendingFileId);
            
            if (isUploaded) {
              data.fileId = data.fileId || data.orderId * -1; // "UPDATE" | "INSERT"
              data.fileName = isUploaded.uploadedOssUrl;
            }
          } else if (d.updateFileCommands.length > 0 && d.updateFileCommands.find(c => c.command === 'DELETE')) {
            data.fileId = null;
            data.fileName = null;
          }

          return data;
        });
      } catch (error) {
        const errorMessage = error && error.message ? error.message : (typeof error === "string" ? error : "文件上传失败，请重试");
        data.validationErrorLog += (data.validationErrorLog ? "; " : "") + errorMessage;
      }

      data.empCompanyId = this.supplierId;
      return data;
    },

    LogPageFormError(errorLogObj, action) {
      LogService.LogFormErrorWithObj({
        EmpCompanyId: this.supplierId,
        PageName: this.$route.path.split("/")[1],
        SectionName: "ClientList",
        Action: action,
      }, errorLogObj);
    },

    //保存
    async Save() {
      var data = await this.AfterSaveResult(false);

      const query = {
        FormId: this.supplierId,
        Action: 'Before_Save',
        FormType: 'Company_ClientList',
        ErrorLog: data.validationErrorLog || ""
      };
      LogService.LogFormDataWithObj(query, data);

      return new Promise((resolve, reject) => {
        CompanyInfoService.SaveClientList(data).then(res => {
          if (res.isSuccessful) {
            this.InitData();
            resolve({
              isSuccessful: true,
              popupAlertMsg: this.$t("lbl_EMPBE_SubmitAlert_SaveSuccessMessage"),
            });
          } else {
            this.LogPageFormError({ res: res }, "Save_SaveClientList");
            reject({
              isSuccessful: false,
              popupAlertMsg: this.$t("lbl_EMPBE_Save_Failed_HasErrorAndCode", { code: res.statusCode, msg: res.msg?.join(",") || "Error" }),
            });
          }
        }).catch(err => {
          this.LogPageFormError({ ErrorName: err.name, ErrorMessage: err.message }, "Save_SaveClientList");
          reject({
            isSuccessful: false,
            popupAlertMsg: this.$t("lbl_EMPBE_Save_Failed_HasError", { msg: err.message }),
            error: err,
          });
        })
      });

    },
    //提交
    async Submit() {
      var data = await this.AfterSaveResult(true);

      const query = {
        FormId: this.supplierId,
        Action: 'Before_Submit',
        FormType: 'Company_ClientList',
        ErrorLog: data.validationErrorLog || ""
      };
      LogService.LogFormDataWithObj(query, data);

      return new Promise((resolve, reject) => {
        CompanyInfoService.SaveClientList(data).then(result => {
          if (result.isSuccessful) {
            this.$refs.ClientList
              .validate(true)
              .then(async (res) => {
                //写日志
                data.VaildError = res.fIldData;
                
                if (process.env.VUE_APP_EMP_ENV_NAME?.toLowerCase() == 'ai' || res.valid) {
                  this.InitData();
                  resolve({
                    isSuccessful: true,
                    isAllMandatoryFieldFilled: true,
                  });
                } else {
                  this.GetData();
                  resolve({
                    isSuccessful: true,
                    isAllMandatoryFieldFilled: false,
                  });
                }
              });
          } else {
            this.LogPageFormError({ result: result }, "Submit_SaveClientList");
            reject({
              isSuccessful: false,
              popupAlertMsg: this.$t("lbl_EMPBE_Submit_Failed_HasErrorAndCode", { code: result.statusCode, msg: result.msg?.join(",") || "Error" }),
            });
          }
        }).catch(err => {
          this.LogPageFormError({ ErrorName: err.name, ErrorMessage: err.message }, "Submit_SaveClientList");
          reject({
            isSuccessful: false,
            popupAlertMsg: this.$t("lbl_EMPBE_Submit_Failed_HasError", { msg: err.message }),
            error: err,
          });
        });
      });
    },

    removeCertImage(deleteCommand) {
      this.removeCertCommands.push(deleteCommand);
    },
  },
};
</script>